import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import Link from '../Link'
import SocialMediaIcons from '../SocialMediaIcons/SocialMediaIcons'
import { PressConstants } from '../../types/press'

interface InquiryWidgetProps {
  contactName: string
  className?: string
  email: string
  lowerSectionClass?: string
}

const InquiryWidget: React.FC<InquiryWidgetProps> = ({
  contactName,
  email,
  className,
  lowerSectionClass,
}) => {
  const { widgetTitle, socialTitle } = PressConstants
  const classes = useStyles()

  return (
    <Box className={className}>
      <Card className={clsx(classes.mediaContact, classes.noRadiusAndShadow)}>
        <CardHeader
          className={clsx(classes.paddingZero, classes.widgetTitle)}
          title={
            <Typography className={classes.letterSpacing} variant="h5">
              {widgetTitle}
            </Typography>
          }
        />
        <CardContent className={classes.paddingZero}>
          <Typography variant="body1">{contactName}</Typography>
        </CardContent>
        <CardActions className={classes.paddingZero}>
          <Link href="mailto:press@talentinc.com">
            <Typography className={classes.semiBold} variant="body1">
              {email}
            </Typography>
          </Link>
        </CardActions>
      </Card>
      <Card
        className={clsx(
          classes.socialConnect,
          classes.noRadiusAndShadow,
          lowerSectionClass
        )}
      >
        <CardHeader
          className={classes.paddingZero}
          title={<Typography variant="body1">{socialTitle}</Typography>}
        />
        <CardActions className={classes.paddingZero}>
          <SocialMediaIcons
            containerClass={classes.socialIconsContainer}
            facebook
            twitter
            linkedIn
          />
        </CardActions>
      </Card>
    </Box>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    letterSpacing: {
      letterSpacing: '0.1em',
    },
    mediaContact: {
      padding: '2rem',
      backgroundColor: theme.palette.background.default,
    },
    noRadiusAndShadow: {
      borderRadius: 0,
      boxShadow: 'none',
    },
    paddingZero: {
      padding: 0,
    },
    socialConnect: {
      backgroundColor: theme.palette.background.default,
      padding: '2.5rem 2rem',
    },
    semiBold: {
      fontWeight: 600,
    },
    socialIconsContainer: {
      marginTop: '0.75rem',
    },
    widgetTitle: {
      marginBottom: '0.5rem',
    },
  })
)
export default InquiryWidget
